const DonationItems = ({
  donationItems,
  handleDelete,
  handleDonationChange,
  donationTotal,
}) => {
  return (
    <div className="bg-white rounded-xl35 p-8 shadow-cartBoxes">
      <h1 className="font-inter text-black text-left !text-2xl !font-light mb-6">
        Donations
      </h1>

      {/* Header row */}
      <div className="flex flex-row w-full mb-4 pb-2 border-b border-gray-200">
        <div className="flex-1 text-left">
          <span className="text-sm font-medium text-gray-600">
            Organization
          </span>
        </div>
        <div className="w-20 text-right">
          <span className="text-sm font-medium text-gray-600">Amount</span>
        </div>
        <div className="w-8"></div>
      </div>

      {donationItems?.length > 0 ? (
        donationItems.map((item, index) => (
          <div key={index} className="my-4">
            <div className="flex flex-row w-full gap-4 items-center">
              {/* Image Section */}
              <div className="w-16 h-16 overflow-hidden border border-gray-200">
                {item.image?.image_url ? (
                  <img
                    src={item.image.image_url}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                    <span className="text-gray-400 text-xs">[Org]</span>
                  </div>
                )}
              </div>

              {/* Donation Info Section */}
              <div className="flex-1 flex flex-col items-start justify-start text-left">
                <h3 className="text-sm font-medium text-gray-800">
                  {item.name || "[Organization]"}
                </h3>
                <p className="text-xs text-gray-500">
                  {item.nonprofit_name || "[Donation title]"}
                </p>
              </div>

              {/* Amount Section */}
              <div className="w-20 text-right">
                <h3 className="text-sm font-medium">
                  ${item.amount ? item.amount.toFixed(2) : "00.00"}
                </h3>
              </div>

              {/* Remove Button */}
              <div className="w-8 flex justify-center">
                <button
                  onClick={() => handleDelete("", item.donation_id)}
                  className="text-gray-400 hover:text-red-500 cursor-pointer text-xl font-bold"
                  title="Remove item"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className="text-center text-gray-500 w-full font-normal text-base p-8">
          No donations have been added to your cart.
        </p>
      )}
    </div>
  );
};

export default DonationItems;
